
import React from "react";
import { Route, Routes } from "react-router-dom";
import List from "../../component/ApplyTest/List";

function BannerPage() {
  return (
    <Routes>
      <Route path="/*" element={<List />} />
      {/*<Route path="/:id" element={<BannerForm />} />*/}
      {/*<Route path="/edit/:id" element={<BannerForm isEdit={true} />} />*/}
      {/*<Route path="/new" element={<BannerForm isEdit={false} />} />*/}
    </Routes>
  );
}

export default BannerPage;
